export default __webpack_public_path__ + "static/media/avatar_fairy_pixie2.60f00d91.mp3";